import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // 更新状态以显示降级的UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // 记录错误详情
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      // 你可以自定义降级UI
      return (
        <div className="flex items-center justify-center min-h-[200px] p-6">
          <div className="text-center">
            <div className="text-gray-500 dark:text-gray-400 mb-2">
              ⚠️ 组件加载出错
            </div>
            <div className="text-sm text-gray-400 dark:text-gray-500">
              {this.props.fallbackMessage || '请刷新页面重试'}
            </div>
            {this.props.showDetails && this.state.error && (
              <details className="mt-4 text-xs text-left">
                <summary className="cursor-pointer text-gray-500">错误详情</summary>
                <pre className="mt-2 bg-gray-100 dark:bg-gray-800 p-2 rounded overflow-auto max-h-32">
                  {this.state.error.toString()}
                  {this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 